import { Component } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { FirebaseRepositoryService } from '../../firebase-repository.service';

@Component({
  templateUrl: './dialog-asignar-trabajador.component.html',
})
export class DialogAsignarTrabajadorComponent {
  task: any;
  workers: any[] = [];
  workerId: string;

  constructor(
    protected ref: NbDialogRef<DialogAsignarTrabajadorComponent>,
    private repoService: FirebaseRepositoryService
  ) {}

  ngOnInit() {
    this.repoService.getWorkersEntidad().subscribe(workers => {
      this.workers = workers;
    });
  }

  asignar() {
    this.ref.close(this.workerId);
  }

  cancelar() {
    this.ref.close();
  }
}